import { render, staticRenderFns } from "./editNew.vue?vue&type=template&id=7ffe8e94&scoped=true&"
import script from "./editNew.vue?vue&type=script&lang=js&"
export * from "./editNew.vue?vue&type=script&lang=js&"
import style0 from "./editNew.vue?vue&type=style&index=0&id=7ffe8e94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe8e94",
  null
  
)

export default component.exports